import { useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import GeneralSettings from '../../components/admin/settings/GeneralSettings';
import ContactSettings from '../../components/admin/settings/ContactSettings';
import EmailSettings from '../../components/admin/settings/EmailSettings';
import PaymentSettings from '../../components/admin/settings/PaymentSettings';
import NotificationSettings from '../../components/admin/settings/NotificationSettings';
import SecuritySettings from '../../components/admin/settings/SecuritySettings';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('general');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'general':
        return <GeneralSettings />;
      case 'contact':
        return <ContactSettings />;
      case 'email':
        return <EmailSettings />;
      case 'payment':
        return <PaymentSettings />;
      case 'notifications':
        return <NotificationSettings />;
      case 'security':
        return <SecuritySettings />;
      default:
        return <GeneralSettings />;
    }
  };

  return (
    <AdminLayout title="Configuración" subtitle="Administra la configuración de la plataforma">
      <div className="settings-container">
        <div className="settings-sidebar">
          <div className="settings-nav">
            <button
              className={`settings-nav-item ${activeTab === 'general' ? 'active' : ''}`}
              onClick={() => handleTabChange('general')}
            >
              <span className="material-icons">settings</span>
              <span>General</span>
            </button>
            <button
              className={`settings-nav-item ${activeTab === 'contact' ? 'active' : ''}`}
              onClick={() => handleTabChange('contact')}
            >
              <span className="material-icons">contact_page</span>
              <span>Contacto</span>
            </button>
            <button
              className={`settings-nav-item ${activeTab === 'email' ? 'active' : ''}`}
              onClick={() => handleTabChange('email')}
            >
              <span className="material-icons">email</span>
              <span>Correo Electrónico</span>
            </button>
            <button
              className={`settings-nav-item ${activeTab === 'payment' ? 'active' : ''}`}
              onClick={() => handleTabChange('payment')}
            >
              <span className="material-icons">payment</span>
              <span>Pagos</span>
            </button>
            <button
              className={`settings-nav-item ${activeTab === 'notifications' ? 'active' : ''}`}
              onClick={() => handleTabChange('notifications')}
            >
              <span className="material-icons">notifications</span>
              <span>Notificaciones</span>
            </button>
            <button
              className={`settings-nav-item ${activeTab === 'security' ? 'active' : ''}`}
              onClick={() => handleTabChange('security')}
            >
              <span className="material-icons">security</span>
              <span>Seguridad</span>
            </button>
          </div>
        </div>
        <div className="settings-content">{renderActiveTab()}</div>
      </div>
    </AdminLayout>
  );
};

export default Settings;
